import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { CategoriaFinanceiraRequest, Response } from './Types';

class CategoriaFinanceiraController {
  public static async Listar(
    request: CategoriaFinanceiraRequest
  ): Promise<Response> {
    try {    
      const response = await Api.post(
        `api/categoriafinanceira/Listar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(
    CategoriaFinanceiraId: number
  ): Promise<Response> {
    try {
      const response = await Api.get(
        `api/categoriafinanceira/ListarUnico/${CategoriaFinanceiraId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: CategoriaFinanceiraRequest
  ): Promise<Response> {
    try {
      const response = await Api.post(
        `api/categoriafinanceira/Adicionar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: CategoriaFinanceiraRequest
  ): Promise<Response> {
    try {
      const response = await Api.put(
        `api/categoriafinanceira/Atualizar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: CategoriaFinanceiraRequest
  ): Promise<Response> {
    try {
      const response = await Api.put(
        `api/categoriafinanceira/Excluir`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default CategoriaFinanceiraController;
